module.exports = __webpack_public_path__ + "static/img/ban03.567b14c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban03.jpeg
// module id = oMvH
// module chunks = 6